import {
  FunktionenstatistikenM1,
  FunktionenstatistikenM2
} from './funktionenstatistiken';
import {GesamtverdienstUndLohnbestandteile} from './gesamtverdienst-und-lohnbestandteile';
import {KennzahlenDerMethodik} from './kennzahlen-der-methodik';
import {KennzahlenZurMethodik} from './kennzahlen-zur-methodik';
import {Lohnsumme} from './lohnsumme';
import {Lohnverteilung} from './lohnverteilung';
import {Personalbestand} from './personalbestand';
import {PersonenUndStellenbezogeneMerkmale} from './personen-und-stellenbezogene-merkmale';
import {PersonenUndStellenbezogeneMerkmaleM2} from './personen-und-stellenbezogene-merkmale-m2';

export class Cockpit {
  personalbestand: Personalbestand;
  gesamtverdienstUndLohnbestandteile: GesamtverdienstUndLohnbestandteile;
  lohnverteilung: Lohnverteilung;
  personenUndStellenbezogeneMerkmale: PersonenUndStellenbezogeneMerkmale;
  lohnsumme: Lohnsumme;
  kennzahlenZurMethodik: KennzahlenZurMethodik;
  funktionenstatistiken: FunktionenstatistikenM1;
}

export class CockpitM2 {
  personalbestand: Personalbestand;
  gesamtverdienstUndLohnbestandteile: GesamtverdienstUndLohnbestandteile;
  lohnverteilung: Lohnverteilung;
  lohnsumme: Lohnsumme;
  personenUndStellenbezogeneMerkmale: PersonenUndStellenbezogeneMerkmaleM2;
  kennzahlenDerMethodik: KennzahlenDerMethodik;
  funktionenstatistiken: FunktionenstatistikenM2;
}
